/*
 * @Author: liuyang
 * @Date: 2019-12-27 16:14:47
 * @LastEditTime: 2020-03-27 15:49:00
 * @LastEditors: Please set LastEditors
 * @Description: vuex相关
 * @FilePath: \trunk\src\store.js
 */

import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
      ct: null,
      ut: null,
      reviewDate: ''
  },
  mutations: {
      setToken(state, info) {
          state.ct = info.ct;
          state.ut = info.ut
      },
      setReviewDate(state, date) {
          state.reviewDate = date;
      }
  },
  actions: {}
});
